import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import desktopBanner from "../../image/79317e0a-d362-451c-9deb-d3a35e20167b.png";
import { FaWhatsapp, FaBoxOpen, FaHandshake, FaListUl, FaHeadset } from 'react-icons/fa';

function Hero({ setShowModal }) {
  const [result, setResult] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setResult("");

    const formData = new FormData(event.target);
    const dataObj = Object.fromEntries(formData.entries());
    dataObj.subject = "New Enquiry from Hero Section";

    try {
      const response = await fetch("/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataObj)
      });

      const data = await response.json();

      if (data.success) {
        navigate("/thank-you");
        event.target.reset();
      } else {
        setResult("Something went wrong while submitting your enquiry. Please try again.");
      }
    } catch (error) {
      setResult("Something went wrong while submitting your enquiry. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      className="hero-section d-none d-md-flex w-100 position-relative"
      style={{
        background: `linear-gradient(rgba(20, 140, 130, 0.55), rgba(20, 140, 130, 0.55)), url(${desktopBanner}) center/cover no-repeat`,
        minHeight: "90vh",
        alignItems: "center"
      }}
    >
      <div className="container py-5 mt-4">
        <div className="row align-items-center">
          {/* Left Side Content */}
          <div className="col-lg-7 text-white text-start pe-lg-5">
            {/* Top Badges */}
            <div className="d-flex gap-2 mb-3 flex-wrap">
              <span className="badge border border-light rounded-pill px-3 py-2 fw-normal" style={{ fontSize: "10px", letterSpacing: "1px", backgroundColor: "transparent" }}>ISO 9001 CERTIFIED</span>
              <span className="badge border border-light rounded-pill px-3 py-2 fw-normal" style={{ fontSize: "10px", letterSpacing: "1px", backgroundColor: "transparent" }}>WHO GMP PRODUCTS</span>
              <span className="badge border border-light rounded-pill px-3 py-2 fw-normal" style={{ fontSize: "10px", letterSpacing: "1px", backgroundColor: "transparent" }}>43+ YEARS IN PCD PHARMA</span>
            </div>

            <h1 className="display-5 fw-bold mb-4" style={{ lineHeight: "1.3" }}>
              India's Trusted <span style={{ color: "#ff6b35" }}>PCD Pharma Franchise</span> Company — Build Your Own Monopoly Pharma Business
            </h1>

            <p className="mb-4" style={{ opacity: 0.95, fontSize: "1.1rem", lineHeight: "1.6" }}>
              With <strong>43+ Years of Experience</strong>, Chemo Biological Limited is a leading PCD Pharma Company offering <strong>25+ Complete Ranges</strong> across Derma, Gynae, Ortho, and more. Partner with the <strong>Best PCD Pharma Franchise Company in India</strong> for genuine monopoly rights, quality products, and complete marketing support.
            </p>

            <div className="d-flex gap-3 mb-5">
              <button onClick={() => setShowModal && setShowModal(true)} className="btn fw-bold px-4 py-2 text-white shadow-sm" style={{ backgroundColor: "#ff6b35", border: "none", borderRadius: "30px" }}>
                Become a Partner <i className="bi bi-arrow-right ms-1"></i>
              </button>
              <a href="https://wa.me/917827552889" target="_blank" rel="noopener noreferrer" className="btn btn-outline-light fw-bold px-4 py-2 d-flex align-items-center gap-2 text-decoration-none" style={{ borderRadius: "30px" }}>
                <FaWhatsapp size={18} /> WhatsApp Us
              </a>
            </div>

            {/* Stats */}
            <div className="row mt-4 g-3">
              <div className="col-3">
                <div className="p-3 text-center rounded-3 shadow-sm" style={{ backgroundColor: "rgba(255, 255, 255, 0.15)", backdropFilter: "blur(5px)", border: "1px solid rgba(255, 255, 255, 0.1)" }}>
                  <FaBoxOpen className="mb-2" style={{ color: "#ff6b35", fontSize: "1.5rem" }} />
                  <h4 className="fw-bold mb-0">500+</h4>
                  <p className="mb-0" style={{ fontSize: "10px", letterSpacing: "1px", textTransform: "uppercase" }}>Products</p>
                </div>
              </div>
              <div className="col-3">
                <div className="p-3 text-center rounded-3 shadow-sm" style={{ backgroundColor: "rgba(255, 255, 255, 0.15)", backdropFilter: "blur(5px)", border: "1px solid rgba(255, 255, 255, 0.1)" }}>
                  <FaHandshake className="mb-2" style={{ color: "#ff6b35", fontSize: "1.5rem" }} />
                  <h4 className="fw-bold mb-0">500+</h4>
                  <p className="mb-0" style={{ fontSize: "10px", letterSpacing: "1px", textTransform: "uppercase" }}>Partners</p>
                </div>
              </div>
              <div className="col-3">
                <div className="p-3 text-center rounded-3 shadow-sm" style={{ backgroundColor: "rgba(255, 255, 255, 0.15)", backdropFilter: "blur(5px)", border: "1px solid rgba(255, 255, 255, 0.1)" }}>
                  <FaListUl className="mb-2" style={{ color: "#ff6b35", fontSize: "1.5rem" }} />
                  <h4 className="fw-bold mb-0">25+</h4>
                  <p className="mb-0" style={{ fontSize: "10px", letterSpacing: "1px", textTransform: "uppercase" }}>Product Range</p>
                </div>
              </div>
              <div className="col-3">
                <div className="p-3 text-center rounded-3 shadow-sm" style={{ backgroundColor: "rgba(255, 255, 255, 0.15)", backdropFilter: "blur(5px)", border: "1px solid rgba(255, 255, 255, 0.1)" }}>
                  <FaHeadset className="mb-2" style={{ color: "#ff6b35", fontSize: "1.5rem" }} />
                  <h4 className="fw-bold mb-0">24x7</h4>
                  <p className="mb-0" style={{ fontSize: "10px", letterSpacing: "1px", textTransform: "uppercase" }}>Support</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Side Form */}
          <div className="col-lg-5 text-center mt-5 mt-lg-0 ps-lg-5">
            <div className="hero-form-card position-relative p-4 bg-white text-dark rounded-4 shadow-lg text-start" style={{ border: "1px dashed rgba(0,0,0,0.1)" }}>
              <div className="form-badge position-absolute px-3 py-1 rounded-pill small fw-bold" style={{ backgroundColor: "#ff6b35", color: "#fff", top: "-15px", left: "20px" }}>
                ENQUIRE NOW
              </div>

              <h3 className="form-heading fw-bold mb-1 mt-2" style={{ color: "#1a2f55", fontSize: "1.5rem", fontFamily: "Georgia, serif" }}>
                Apply for PCD Pharma Franchise
              </h3>
              <p className="text-muted small mb-4">(Do not send Job Queries)</p>

              <form className="hero-form" onSubmit={onSubmit}>
                <div className="mb-3">
                  <input type="text" name="name" className="form-control" placeholder="Your Name*" required style={{ padding: "10px 15px", borderColor: "#e0e0e0" }} />
                </div>
                <div className="mb-3">
                  <input type="email" name="email" className="form-control" placeholder="Email*" pattern="^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$" title="Please enter a valid email address" required style={{ padding: "10px 15px", borderColor: "#e0e0e0" }} />
                </div>
                <div className="mb-3">
                  <input type="tel" name="phone" className="form-control" placeholder="Phone Number*" pattern="[0-9]{10}" maxLength="10" minLength="10" title="Please enter a valid 10-digit phone number" required style={{ padding: "10px 15px", borderColor: "#e0e0e0" }} />
                </div>
                <div className="mb-3">
                  <input type="text" name="city" className="form-control" placeholder="Your City*" required style={{ padding: "10px 15px", borderColor: "#e0e0e0" }} />
                </div>
                <div className="mb-4">
                  <textarea name="message" className="form-control" rows="2" placeholder="Message" style={{ padding: "10px 15px", borderColor: "#e0e0e0", resize: "none" }}></textarea>
                </div>
                <button type="submit" disabled={isSubmitting} className="btn px-4 py-2 text-white border-0 fw-bold rounded-2 w-100 mb-2" style={{ backgroundColor: "#3a9add", padding: "12px" }}>
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
                {result && <div className="text-center small mt-2 fw-bold text-danger">{result}</div>}
              </form>
            </div>

            {/* Call Button */}
            <div className="mt-4">
              <a href="tel:+917827552889" className="btn fw-bold px-5 py-2 text-white shadow" style={{ backgroundColor: "#ff6b35", border: "none", borderRadius: "30px", fontSize: "1.1rem" }}>
                <i className="bi bi-telephone-fill me-2"></i> Call Now: +91 7827552889
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
